<template>
    <div>
        <div class="wrap1200 breadcrumb">
            <breadcrumb></breadcrumb>
        </div>
        <div class="main_box clearfix">
            <div class="leftside">
                <dl class="lot_nav">
                    <dt>选择彩种</dt>
                    <dd>
                        <strong>热门彩种</strong>
                        <a @click="goToDetail(1)" style="position:relative;">双色球</a>
                        <a @click="goToDetail(3)" style="position:relative;">大乐透</a>&ensp;&ensp;
                        <a @click="goToDetail(5)">福彩3D</a>&ensp;
                        <a @click="goToDetail(6)" class="mr0">排列三</a>
                    </dd>
                    <dd>
                        <strong>福利彩票</strong>
                        <a @click="goToDetail(1)" style="position:relative;">双色球</a>
                        <a @click="goToDetail(5)">福彩3D</a>
                        <a @click="goToDetail(9)">七乐彩</a>
                        <a @click="goToDetail(10)">15选5</a>
                        <a @click="goToDetail(11)">东方6+1</a>
                        <a @click="goToDetail(12)">快乐8</a>
                    </dd>
                    <dd>
                        <strong>体育彩票</strong>
                        <a @click="goToDetail(3)" style="position:relative;">大乐透</a>
                        <a @click="goToDetail(8)" target="_blank">七星彩</a>
                        <a @click="goToDetail(6)" target="_blank" class="mr0">排列3</a>
                        <a @click="goToDetail(7)" target="_blank" style="position:relative;">排列5</a>
                    </dd>
             <!--       <dd class="border0">
                        <strong>地方彩票</strong>
                        <a href="/guangdong/" target="_blank">广东</a>
                        <a href="/jiangsu/" target="_blank">江苏</a>
                        <a href="/fujian/" target="_blank">福建</a>
                        <a href="/anhui/" target="_blank">安徽</a>
                    </dd> -->
                </dl>
            </div>
            <div class="home_kjgg ml20">
                <router-view></router-view>
                <div v-if="currentRouteName === '开奖公告'">
                    <div class="liveDigEnter clearfix mb20">
                        <a @click="gotoliveVidos('fc')" class="fc">
                            <h3>福彩开奖直播</h3>
                            <p>每天21:15开奖</p>
                            <p>开奖彩种：双色球、福彩3D、七乐彩</p>
                        </a>
                        <a @click="gotoliveVidos('tc')" class="tc">
                            <h3>体彩开奖直播</h3>
                            <p>每天20:00开始直播，20:25开奖</p>
                            <p>开奖彩种：大乐透、排列三/五、七星彩</p>
                        </a>
                    </div>
                    <div class="lot_kjgg" style="height:initial;">
                        <ul class="lot_kjul clearfix">
                            <li v-for="(item,index) in this.lotteryData.lottery?this.lotteryData.lottery.slice(0,5):[]">
                                <a href="javascript:;" target="_blank">
                                    <div class="img">
                                        <img v-if="item.lottery_code == 'ssq'" src="../assets/i64_ssq.png" />
                                        <img v-if="item.lottery_code == 'dlt'" src="../assets/i64_dlt.png" />
                                        <img v-if="item.lottery_code == 'fcsd'" src="../assets/i48_fc3d.png" />
                                        <img v-if="item.lottery_code == 'pls'" src="../assets/i48_pl3.png" />
                                        <img v-if="item.lottery_code == 'plw'" src="../assets/i48_pl5.png" />
                                    </div>
                                </a>
                                <p class="lot_qs">
                                    <a href="javascript:;" class="lot_name">
                                        {{ item.lottery_name }}
                                    </a>
                                    <strong>{{item.result.lottery_no}}期</strong>
                                    开奖日期：{{item.result.lottery_date.substring(5)}}  <span>每{{convertWeekdays(item.kaijiangriqi)}}开奖</span>
                                </p>
                                <div class="lot_mub clearfix">
                                    <div class="kj_ball lot_i">
                                        <i v-for="el in item.result.redballs">{{el}}</i>
                                        <template v-if="item.result.blueballs.length > 0">
                                            <i class="blue" v-for="el in item.result.blueballs">{{ el }}</i>
                                        </template>
                                    </div>
                                    <span class="lot_text" v-if="index < 2">奖池滚存：<i class="red">￥{{ parseInt(item.result.lottery_pool_amount).toLocaleString('en-US') }}</i>元</span>
                                    <span class="lot_text" v-if="index >= 2">天天开 易中奖</span>
                                    <a @click="goToDetail(item.id)" target="_blank" class="xq_link">详细</a>
                                </div>
                                <a @click="gotoliveVidos(item.lottery_type)" class="addVedio">
                                    <i class="el-icon-caret-right"></i>开奖视频
                                </a>
                                <div class="lskj_li">
                                    <p class="lskj_p">
                                        <a @click="goToCharts(item.id)" class="xq_link" target="_blank">号码走势</a>
                                    </p>
                                </div>
                            </li>
                        </ul>
                    </div>
                    <div class="fl_lot mt20">
                        <div class="fl_title">
                            <h2><img class="fl_tit" src="../assets/flcp.png">福利彩票</h2>
                        </div>
                        <div class="cp_tab">
                            <table width="100%" border="0" cellspacing="0" cellpadding="0" style="font-size: 12px">
                                <thead>
                                        <tr>
                                            <th width="80">彩种</th>
                                            <th width="75">期号</th>
                                            <th width="220">开奖号码</th>
                                           <!-- <th width="120">本期卖点</th> -->
                                            <th width="100">开奖视频</th>
                                            <th width="95">开奖时间</th>
                                            <th width="70">开奖日</th>
                                            <th width="55">走势</th>
                                        </tr>
                                </thead>
                                <tbody>
                                    <template v-for="(item,index) in this.lotteryData.lottery?this.lotteryData.lottery.slice(3,10):[]">
                                        <tr v-if="item.lottery_type == 'fc'">
                                            <td><a href="/qlc/">{{item.lottery_name}}</a></td>
                                            <td><i class="c333">{{item.result.lottery_no}}期</i></td>
                                            <td class="tdleft">
                                                <div class="kj_ball1">
                                                    <i v-for="el in item.result.redballs">{{el}}</i>
                                                    <template v-if="item.result.blueballs.length > 0">
                                                        <i class="blue" v-for="el in item.result.blueballs">{{ el }}</i>
                                                    </template>
                                                </div>
                                            </td>
                                           <!-- <td><i class="c999">单注最高可中500万</i></td> -->
                                            <td>
                                                <el-button type="warning" class="addVedio" icon="el-icon-caret-right" @click="gotoliveVidos(item.lottery_type)"></el-button>
                                            </td>
                                            <td>{{item.result.lottery_date.substring(5)}} {{ item.result.week_day_text }}</td>
                                            <td>每{{convertWeekdays(item.kaijiangriqi)}}</td>
                                            <td><i class="el-icon-data-line xq_link" @click="goToCharts(item.id)"></i></td>
                                        </tr>
                                    </template>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div class="fl_lot mt20">
                        <div class="fl_title">
                            <h2><img class="fl_tit" src="../assets/tycp.png">体育彩票</h2>
                        </div>
                        <div class="cp_tab">
                            <table width="100%" border="0" cellspacing="0" cellpadding="0" style="font-size: 12px">
                                <thead>
                                        <tr>
                                            <th width="80">彩种</th>
                                            <th width="75">期号</th>
                                            <th width="220">开奖号码</th>
                                           <!-- <th width="120">本期卖点</th> -->
                                            <th width="100">开奖视频</th>
                                            <th width="95">开奖时间</th>
                                            <th width="70">开奖日</th>
                                            <th width="55">走势</th>
                                        </tr>
                                </thead>
                                <tbody>
                                    <template v-for="(item,index) in this.lotteryData.lottery?this.lotteryData.lottery.slice(3,10):[]">
                                        <tr v-if="item.lottery_type == 'tc'">
                                            <td><a href="/qlc/">{{item.lottery_name}}</a></td>
                                            <td><i class="c333">{{item.result.lottery_no}}期</i></td>
                                            <td class="tdleft" @click="gotoliveVidos(item.lottery_type)">
                                                <div class="kj_ball1">
                                                    <i v-for="el in item.result.redballs">{{el}}</i>
                                                    <template v-if="item.result.blueballs.length > 0">
                                                        <i class="blue" v-for="el in item.result.blueballs">{{ el }}</i>
                                                    </template>
                                                </div>
                                            </td>
                                           <!-- <td><i class="c999">单注最高可中500万</i></td> -->
                                            <td>
                                                <el-button type="warning" class="addVedio" icon="el-icon-caret-right" @click="gotoliveVidos(item.lottery_type)"></el-button>
                                            </td>
                                            <td>{{item.result.lottery_date.substring(5)}} {{ item.result.week_day_text }}</td>
                                            <td>每{{convertWeekdays(item.kaijiangriqi)}}</td>
                                            <td><i class="el-icon-data-line xq_link" @click="goToCharts(item.id)"></i></td>
                                        </tr>
                                    </template>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { getIndexList } from '@/api/index';
import Breadcrumb from '../components/Breadcrumb.vue';
export default {
  name: 'App',
  components: {
    Breadcrumb
  },
  data(){
    return{
        lotteryData:[],

    }
  },
  computed: {
    currentRouteName() {
      return this.$route.name;
    }
  },
  mounted(){
    this.indexLotteryList();
  },
  methods:{
    indexLotteryList() {
        getIndexList().then(res => {
            console.log(res,'res')
            this.lotteryData = res.data.data;
            console.log(this.lotteryData,'this.lotteryData')
        })
        .catch(error => {
          console.error('Error fetching user list:', error);
        });
    },
    convertWeekdays(weekdays) {
      const weekdayMap = {
        0: '日',
        1: '一',
        2: '二',
        3: '三',
        4: '四',
        5: '五',
        6: '六'
      };
      const weekdayArray = weekdays.split(',');
      if (weekdayArray.length === 7 && new Set(weekdayArray).size === 7) {
        return '日';
      }
      const convertedArray = weekdayArray.map(day => weekdayMap[day]);
      return '周' + convertedArray.join('、');
    },
    goToDetail(id){
      switch(id)
      {
        case 1:
          this.$router.push({ name: '福彩双色球' });
          break;
        case 3:
          this.$router.push({ name: '体彩大乐透' });
          break;
        case 5:
          this.$router.push({ name: '福彩3D' });
          break;
        case 6:
          this.$router.push({ name: '排列三' });
          break;
        case 7:
          this.$router.push({ name: '15选5' });
          break;
        case 8:
          this.$router.push({ name: '七星彩' });
          break;
        case 9:
          this.$router.push({ name: '七乐彩' });
          break;
        case 10:
          this.$router.push({ name: '15选5' });
          break;
        case 11:
          this.$router.push({ name: '东方6+1' });
          break;
        case 12:
          this.$router.push({ name: '快乐8' });
          break;

      }
    },
    goToCharts(id){
      var pathName = '';
      var tabName = '';
      switch(id)
      {
        case 1:
          pathName = 'ssqindex';
          tabName = 'jbzs';
          break;
        case 3:
          pathName = 'dltindex';
          tabName = 'jbzs';
          break;
        case 5:
          pathName = 'fcsdindex';
          tabName = 'zxzs';
          break;
        case 6:
          pathName = 'plsindex';
          tabName = 'zxzs';
          break;
        case 7:
          pathName = 'plwindex';
          tabName = 'zxzs';
          break;
        case 8:
          pathName = 'qxcindex';
          tabName = 'zxzs';
          break;
        case 9:
          pathName = 'qlcindex';
          tabName = 'jbzs';
          break;
        case 10:
          pathName = 'swxwindex';
          tabName = 'jbzs';
          break;
        case 11:
          pathName = 'df61index';
          tabName = 'jbzs';
          break;
        case 12:
          pathName = 'kl8index';
          tabName = 'jbzs';
          break;

      }

      // ✅ 非空判断
      if (pathName && tabName) {
        this.$router.push({ path: '/trendChart/' + pathName, query: { tab: tabName } });
      } else {
        // 如果用 Element UI
        this.$message.warning('无效的图表 ID，无法跳转');
        // 如果用浏览器自带提示
        // alert('无效的图表 ID，无法跳转');
      }
    },
    gotoliveVidos(lottery_type){
       switch(lottery_type)
       {
         case 'fc':
           this.$router.push({ name: '福彩直播' });
           break;
         case 'tc':
           this.$router.push({ name: '体彩直播' });
           break;
       }
    }

  }
};
</script>
<style scopeds>
.wrap1200 {
    width: 1200px;
    margin-left: auto;
    margin-right: auto;
    position: relative;
}
.breadcrumb {
    height: 44px;
    color: #999;
    display: flex;
    align-items: center;
}
.main_box {
    width: 1200px;
    margin: 0 auto;
}
.clearfix:after{
    clear:both;
    content:".";
    display:block;
    height:0;
    visibility:hidden
    }
.clearfix{
    zoom:1
}
.leftside {
    width: 230px;
    float: left;
}
.lot_nav {
    background: #fff;
    position: relative;
    height: auto;
    width: 230px;
    zoom: 1;
    border-radius: 6px;
}
.lot_nav dt {
    border-bottom: 1px solid #ee8600;
    height: 38px;
    line-height: 38px;
    font-size: 14px;
    font-weight: bold;
    color: #ee8600;
    padding-left: 15px;
}
.lot_nav dd {
    padding: 6px 0 13px 15px;
    line-height: 24px;
    border-bottom: 1px solid #eee;
    border-top: 1px solid #FFF;
    color: #999;
}
.lot_nav dd strong {
    display: block;
}
.lot_nav a {
    margin-right: 18px;
    display: inline-block;
    padding: 0 2px;
    color: #333;
}
a:hover {
    color: #EA4747;
}
dd.border0, .border0, li.border0 {
    border: 0;
}
.home_kjgg {
    float: left;
    width: 950px;
    border-radius: 6px;
    overflow: hidden;
}
.ml20 {
    margin-left: 20px;
}
.mb20 {
    margin-bottom: 20px;
}
.liveDigEnter{
    display: flex;
    justify-content: space-between;
}
.liveDigEnter .fc {
    background: url("../assets/fcBg.png");
    background-size: cover;
}
.liveDigEnter .tc {
    background: url("../assets/tcBg.png");
    background-size: cover;
}
.liveDigEnter h3 {
    padding-left: 30px;
    margin-top: 20px;
    font-size: 24px;
    margin-bottom: 5px;
}
.liveDigEnter p {
    padding-left: 30px;
    font-size: 12px;
    margin-bottom: 2px;
}
.liveDigEnter a {
    color: #fff;
    display: block;
    width: 465px;
    height: 118px;
}
.lot_kjgg {
    height: 460px;
    background: #fff;
    border-radius: 6px;
}
.lot_kjul li {
    border-bottom: 1px solid #f2f2f2;
    height: 68px;
    padding: 15px 0 15px 90px;
    border-top: 1px solid #FFF;
    position: relative;
    zoom: 1;
    color: #666;
}
.lot_kjul .img {
    position: absolute;
    left: 10px;
    top: 15px;
    width: 54px;
    height: 54px;
    background: rgba(245, 244, 241, 1);
    border: 1px solid rgba(217, 217, 217, 1);
    border-radius: 50%;
    padding: 4px;
}
.lot_kjul .img img {
    width: 54px;
    height: 54px;
    border-radius: 50%;
}
.lot_qs {
    line-height: 22px;
}
.lot_name {
    font-size: 14px;
    font-weight: bold;
    color: #333;
}
.lot_qs strong {
    margin: 0 8px;
}
.lot_mub {
    margin-top: 8px;
    position: relative;
    zoom: 1;
    line-height: 26px;
}
.kj_ball i {
    background: #ed1c24;
    width: 25px;
    height: 25px;
    line-height: 22px;
    display: inline-block;
    text-align: center;
    font-size: 12px;
    font-weight: bold;
    color: #FFF;
    font-family: 'SimSun';
    margin-right: 3px;
    border-radius: 15px;
    font-style: normal;
}
.kj_ball i.blue {
    background: #0072bc;
}
.lot_text {
    padding-left: 10px;
    color: #666;
}
.lot_i {
    float: left;
}
.red {
    color: #e60012;
}
i{
    font-style: normal;
}
a.xq_link {
    margin-left: 35px;
    color: #666;
    text-decoration: underline !important;
}
.addVedio:hover {
    right: 247px;
    color: #FFF;
}
.addVedio {
    -webkit-transition: all .2s ease;
    -moz-transition: all .2s ease;
    -o-transition: all .2s ease;
    -ms-transition: all .2s ease;
    transition: all .2s ease;
}
.addVedio {
    position: absolute;
    top: 35px;
    right: 253px;
    width: 90px;
    height: 30px;
    line-height: 30px;
    text-align: center;
    background: #FF8200;
    border-radius: 4px;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
}
.addVedio i {
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 18px;
}
.lskj_li {
    position: absolute;
    right: 0;
    top: 0;
    width: 208px;
    padding: 40px 0 0 5px;
}
.lskj_p {
    color: #ddd;
    text-align: right;
    padding-right: 12px;
}
.lskj_p a {
    margin: 0 8px;
    color: #333;
}
.fl_lot {
    padding: 8px 20px 0;
    background: #FFF;
    border-radius: 6px;
}
.mt20 {
    margin-top: 20px;
}
.fl_title {
    margin-top: 4px;
    position: relative;
    padding: 0 5px;
}
.fl_title h2 {
    font-size: 18px;
    font-family: 'Microsoft YaHei';
}
.fl_tit {
    width: 28px;
    height: 26px;
    display: inline-block;
    margin-right: 4px;
    vertical-align: middle;
}
.cp_tab {
    margin-top: 10px;
}
.cp_tab table {
    color: #666;
}
.cp_tab td {
    height: 40px;
    text-align: center;
}
.cp_tab td a {
    color: #333;
}
.cp_tab td a:hover {
    color: #e60012;
}
i {
    font-style: normal;
}
td.tdleft {
    text-align: left;
    padding-left: 20px;
}
td.tdleft {
    text-align: left;
    padding-left: 20px;
}
.kj_ball1 {
  display: flex;
  flex-wrap: wrap; /* 允许换行 */
  max-width: calc(22px * 10); /* 限制一行最大宽度，比如每个球30px，10个球宽度 */
}
.kj_ball1 i {
    font-family: 'Tahoma';
    font-weight: bold;
    color: #ed1c24;
    margin-right: 5px;
}
.kj_ball1 i.blue {
    color: #1e88d2;
}
.c999 {
    color: #999;
}
.el-button--warning {
    background: #FF8200 !important;
    border-color: #FF8200 !important;
    color: #FFF;
}
.cp_tab .addVedio {
    position: static;
    display: inline-flex;
    width: 24px;
    height: 24px;
    text-align: center;
}
.el-icon-data-line{
    color: #2eb570;
    font-size: 18px;
}
.w280 {
    width: 280px;
}
.fr {
    float: right;
    display: inline;
}
.asideliveEnter.fc {
    background: url("../assets/fcBg01.png");
    background-size: 100% 100%;
}
.asideliveEnter {
    color: #fff;
    width: 280px;
    height: 100px;
}
.asideliveEnter h3 {
    padding-left: 30px;
    padding-top: 23px;
    font-size: 24px;
    font-weight: bold;
}
.asideliveEnter p {
    padding-left: 30px;
    font-size: 12px;
    opacity: .7;
}
.downEwmWrap {
    width: 280px;
    /* height: 440px; */
}
.downEwmBlock {
    background: #fff;
    border-radius: 8px;
}
.titleI {
    display: flex;
    align-items: center;
    padding: 15px 20px;
    height: 28px;
    line-height: 28px;
}
.titleI h2 {
    display: flex;
    align-items: center;
    flex: 1;
    font-size: 20px;
}
.downEwmBlock .ttzs.app {
    /* width: 280px;
    height: 201px; */
    margin: 0 auto;
    /* background: linear-gradient(180deg, #fff8f8, #ffffff); */
    /* background: url("../assets/appEwmBg.png"); */
}
.downEwmBlock .ttzs {
    box-sizing: border-box;
    position: relative;
    border-radius: 6px;
    /* height: 170px; */
    padding: 0px 10px 6px 10px;
    img{
        width: 100%;
    }
}
.downEwmBlock .info {
    color: #333;
}
.downEwmBlock .info img {
    float: left;
    margin-right: 8px;
    width: 48px;
    height: 48px;
}
.downEwmBlock .info .txt {
    float: left;
}
.downEwmBlock .info .txt h2 {
    padding-top: 2px;
    font-size: 16px;
    font-weight: bold;
}
.downEwmBlock .info .txt p {
    font-size: 12px;
    opacity: .7;
}
.downEwmBlock .ttzs > p {
    font-size: 14px;
    line-height: 20px;
    color: #999;
    margin-top: 12px;
}
.downEwmBlock .ttzs > p {
    font-size: 14px;
    line-height: 20px;
    color: #999;
    margin-top: 12px;
}
.clearfix:after {
    clear: both;
    content: ".";
    display: block;
    height: 0;
    visibility: hidden;
}
.downEwmBlock .ttzs.app .ewm {
    right: 10px;
}
.downEwmBlock .ewm {
    box-sizing: border-box;
    position: absolute;
    right: 20px;
    bottom: 20px;
    width: 100px;
    height: 100px;
    background: #fff;
    border-radius: 4px;
    overflow: hidden;
    border: 1px solid #eee;
}
.downEwmBlock .ewm img {
    width: 100%;
    height: 100%;
}
.mt10 {
    margin-top: 10px;
}
.xq_link {
  cursor: pointer;
}

</style>



// WEBPACK FOOTER //
// src/views/drawNotice.vue